import { render } from "./Errors.vue?vue&type=template&id=693955b2"
import script from "./Errors.vue?vue&type=script&lang=js"
export * from "./Errors.vue?vue&type=script&lang=js"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__